import * as React from 'react';
import { flow } from 'lodash';
import { withJob } from 'react-jobs';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { reset, destroy } from 'redux-form';
import { IStore } from '../../../../redux/IStore';
import Loading from '../../../../components/Loading';
import { Row, Button, Tabs, Tab } from 'react-bootstrap';
import { IAuthState } from '../../../../services/auth/models';
import { IQuoteActions } from '../../../../services/quote/models';
import { IBrandingActions } from '../../../../services/branding/models';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { actions as brandingActions } from '../../../../services/branding/reducer';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';
import {Email} from '../../../../components/Email';
import UpdateEmailModal from '../UpdateEmailModal';
import UpdateCardModal from '../UpdateCardModal';
import {translateStatus} from '../../../../util/helpers';
import {isUndefined} from 'util';

interface IAccountSummaryProps {
  auth: IAuthState;
  actions: {
    auth: IAuthActions;
    quote: IQuoteActions;
    reset(formName: string);
    destroy(formName: string);
    branding: IBrandingActions,
    push: (route: string) => void;
  };
}

class AccountSummary extends React.Component<IAccountSummaryProps> {
  private renderPolicyLink = (cell, row) => {
    return (
      <div>
        <Link to={`/account/policies/${row.id}`} className={'policy-docs-link'}>
          Voir
        </Link>
      </div>
    );
  }

  private renderQuoteLink = (cell, row) => {
    return (
      <Link to={`/account/quotes/${row.id}`} className={'policy-docs-link'}>
        Voir votre devis
      </Link>
    );
  }

  private renderRenewalLink = (cell, row) => {
    return (
      <Link to={`/account/policies/${row.id}`} className={'policy-docs-link'}>
        Voir
    </Link>
    );
  }

  private renderInsuredDetails = (cell, row) => {
    if (!cell) {
      return null;
    }

    let content = <span>{cell.title} {cell.firstName} {cell.lastName}</span>;
    if (cell.firstName === 'Test' || cell.lastName === 'Test') {
      content = <span>-</span>;
    }

    return (
      content
    );
  }

  private renderStatus = (cell, row) => {
    const isDisplayPolicy = ! isUndefined(row.policyNumber);
    return (
      <Link to={`/account/` + (isDisplayPolicy ? 'policies' : 'quotes') + `/${row.id}`}>
        {translateStatus(row.status)}
      </Link>
    );

  }

  public render() {
    const { auth, actions } = this.props;
    const defaultTab = auth.customer.policies.length > 0 ? 1 : 2;

    return (
      <Row className="page-container animated fadeIn">
        <div className="customer-section-title">
          <h1>Bienvenue {auth.customer.firstName !== 'Test' ? auth.customer.firstName : ''}</h1>
        </div>
        <Tabs defaultActiveKey={defaultTab} id="your-account-tabs" className="your-account-tabs">
          {auth.customer.policies.length > 0 && (
            <Tab eventKey={1} title="Police(s)">
              <div className="white-section customer-table">
                <BootstrapTable data={auth.customer.policies}>
                  <TableHeaderColumn
                    dataField="policyNumber"
                    isKey={true}
                    width="20%"
                    dataSort={true}
                  >
                    Numéro de police
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="insured"
                    width="20%"
                    dataSort={true}
                  >
                    Assuré(s)
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="commencesAt"
                    width="20%"
                    dataSort={true}
                  >
                    Date d'effet
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="status"
                    width="20%"
                    dataSort={true}
                    dataFormat={this.renderStatus}
                  >
                    État
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    width="20%"
                    dataFormat={this.renderPolicyLink}
                  />
                </BootstrapTable>

                <div className="alert alert-default margin-top no-padding-left no-padding-right">
                  <p>
                    <strong>
                      Si vous avez des questions,
                      vous pouvez nous écrire à <Email email={'e-rcpro.france@msamlin.com'} />
                      &nbsp;ou nous contacter au +33 (0) 1 44 70 71 00
                    </strong>
                  </p>
                </div>
              </div>
            </Tab>
          )}
        </Tabs>
        <div className="btn-bar policy-detail">
          <Button
            className={'btn-secondary'}
            type="submit"
            onClick={actions.auth.logout}
          >
            Déconnexion
          </Button>
          <UpdateEmailModal
            email={auth.customer.email}
            phone1={auth.customer.phone1}
          />
          <UpdateCardModal />
        </div>
      </Row>
    );
  }
}

export default flow([
  withJob({
    work: (props: IAccountSummaryProps) => {
      const promises = [];

      promises.push(props.actions.auth.reloadCustomer());

      return Promise.all(promises);
    },
    LoadingComponent: (props) => <Loading/>,
    ErrorComponent: ({ error }) => {
      console.error(error);

      return (
        <div>
          {error.message}
        </div>
      );
    },
  }),
  connect(
    (state: IStore) => {
      return {
        auth: state.auth,
        quote: state.quote,
        branding: state.branding,
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        reset: bindActionCreators(reset, dispatch),
        destroy: bindActionCreators(destroy, dispatch),
        auth: bindActionCreators({...authActions}, dispatch),
        quote: bindActionCreators({ ...quoteActions }, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
      },
    }),
  ),
])(AccountSummary);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/scenes/AccountSummary/index.tsx